import React from "react";
import { Element } from "react-scroll";

import PageWrapper from "../components/PageWrapper";
import Hero from "../sections/main/Hero";
import Works from "../sections/main/Works";
import Contact from "../sections/main/Contact";

const IndexPage = () => {
    return (
    <>
      <PageWrapper>
        <Element name="works">
          <Works />
        </Element>

        <Contact />
      </PageWrapper>
    </>
  );
};
export default IndexPage;
